import React, { useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { useParams } from 'react-router-dom';
import { useDataEventsDispatch, usePracticeViewerState } from 'store/hooks';

import TabSelector from '../../../../Shared/Filters/TabSelector/index';
import { PVHeader as PVHeaderProps, Field } from '../../types';

const PVHeader = ({ field, fields, onPlay, setField, setOnPlay, setWasOnPlay } : PVHeaderProps) => {

  const { id: practiceId } = useParams<{ id: string }>();
  const { practiceData } = usePracticeViewerState();

  const { getSpecificFieldImage } = useDataEventsDispatch();

  const [dropdown, setDropdown] = useState(false);

  const handleDropdownSelect = (field: Field, index: number) => {
    if (field.image) {
      setField({...field, fieldIndex: index });
    } else {
      // if the field base64 image isn't stored in redux yet
      setWasOnPlay(onPlay);
      setOnPlay(false);
      setField({...field, isLoading: true, fieldIndex: index });
      getSpecificFieldImage(practiceData.homeTeam.teamId, practiceId, index);
    }
  };

  const tabSelectorProps = {
    show: dropdown,
    open: () => setDropdown(true),
    close: () => setDropdown(false)
  };

  return (
    <>
      <TabSelector {...tabSelectorProps} />

      <Dropdown className="pv-dropdown">
        <Dropdown.Toggle id="dropdown-basic" className="btn-border" style={{width: '100%'}}>
          <label>PRACTICE AREA</label>
          <span>{field.areaName}</span>
        </Dropdown.Toggle>

        <Dropdown.Menu style={{ boxShadow: '0 0 6px rgba(0, 0, 0, 0.2)' }}>
          {fields.map((field, index) =>
            <Dropdown.Item
              key={field._id}
              onClick={() => handleDropdownSelect(field, index)}
            >{field.areaName}</Dropdown.Item>
          )}
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default PVHeader;